const STATUS_LABELS = {
  active: "Active",
  completed: "Completed",
  scheduled: "Scheduled",
  cancelled: "Cancelled",
  aborted: "Aborted",
  pending: "Pending",
  paused: "Paused",
};

function formatPhoneAccountLabel(account) {
  const name = account.phoneName || account.wabaName || "Account";
  const number = account.phoneNumber || "";
  return number ? `${name} · ${number}` : name;
}

function formatDisplayDate(value) {
  if (!value) return "";
  const d = new Date(`${value}T12:00:00`);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleDateString(undefined, {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

/**
 * Build display chips for applied campaign list filters.
 */
export function buildAppliedFilterChips(filters, { phoneAccounts = [], templates = [] } = {}) {
  const chips = [];

  if (filters.campaign_name?.trim()) {
    chips.push({
      key: "campaign_name",
      field: "campaign_name",
      label: `Name: ${filters.campaign_name.trim()}`,
    });
  }

  if (filters.status) {
    chips.push({
      key: "status",
      field: "status",
      label: `Status: ${STATUS_LABELS[filters.status] || filters.status}`,
    });
  }

  if (filters.template_id) {
    const template = templates.find((t) => String(t.id) === String(filters.template_id));
    chips.push({
      key: "template_id",
      field: "template_id",
      label: `Template: ${template?.name || filters.template_id}`,
    });
  }

  if (filters.whatsapp_account_id) {
    const account = phoneAccounts.find(
      (a) => String(a.phoneId) === String(filters.whatsapp_account_id)
    );
    chips.push({
      key: "whatsapp_account_id",
      field: "whatsapp_account_id",
      label: `Account: ${account ? formatPhoneAccountLabel(account) : filters.whatsapp_account_id}`,
    });
  }

  if (filters.date_from) {
    chips.push({
      key: "date_from",
      field: "date_from",
      label: `From: ${formatDisplayDate(filters.date_from)}`,
    });
  }

  if (filters.date_to) {
    chips.push({
      key: "date_to",
      field: "date_to",
      label: `To: ${formatDisplayDate(filters.date_to)}`,
    });
  }

  return chips;
}

export function hasActiveCampaignFilters(filters) {
  return Object.values(filters || {}).some((v) => v !== "" && v !== null && v !== undefined);
}

export function emptyCampaignFilters() {
  return {
    status: "",
    campaign_name: "",
    template_id: "",
    whatsapp_account_id: "",
    date_from: "",
    date_to: "",
  };
}

/**
 * Clear a single filter field (whatsapp change also clears template).
 */
export function clearCampaignFilterField(filters, field) {
  const next = { ...filters, [field]: "" };
  if (field === "whatsapp_account_id") {
    next.template_id = "";
  }
  return next;
}
